/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-01-11 15:35:57
 * @LastEditTime: 2019-03-27 18:09:37
 */
const getters = {
    token: state => state.user.token,
    username: state => state.user.username,
    userid: state => state.user.userid,
    phone: state => state.user.phone,
    isPrimary: state => state.user.isPrimary,
    islogin: state => state.user.islogin,
    roles: state => state.user.roles,
    permission_routers: state => state.permission.routers,
    addRouters: state => state.permission.addRouters,
    menuTop: state => state.menu.menuTop,
    activeIndex: state => state.menu.activeIndex,
    activeMenu: state => state.menu.activeMenu,
    brotherMenu: state => state.menu.brotherMenu,
    breadcrumbList: state => state.menu.breadcrumbList,
    childMenu: state => state.menu.childMenu,
    bannerPath: state => state.menu.bannerPath,
    contentlist: state => state.menu.contentlist,
    content: state => state.menu.content,
    articleContent: state => state.menu.articleContent,
    parentList: state => state.menu.parentList,
    outhref: state => state.menu.outhref,
    userName: state => state.menu.userName,
    userNameLogin: state => state.user.userNameLogin,
    userPhone: state => state.user.userPhone,
    userMail: state => state.user.userMail,
    userIds: state => state.user.userIds,
    rightList: state => state.menu.rightList,
    saveUser: state => state.menu.saveUser
};
export default getters;
